import { render, staticRenderFns } from "./DownloadArea.vue?vue&type=template&id=3a6ede37&scoped=true&"
import script from "./DownloadArea.vue?vue&type=script&lang=js&"
export * from "./DownloadArea.vue?vue&type=script&lang=js&"
import style0 from "./DownloadArea.vue?vue&type=style&index=0&id=3a6ede37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6ede37",
  null
  
)

export default component.exports